import { render, staticRenderFns } from "./file-grid-item.vue?vue&type=template&id=32e721a2"
import script from "./file-grid-item.vue?vue&type=script&lang=js"
export * from "./file-grid-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports